import React, { useState } from "react"
import { createPortal } from "react-dom"
import { Box } from "@mui/material"
import { REPORT_ROUTES } from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import { ReportIconsLegend } from "Pages/ReportsAlerts/Reports/@components"
import { reportListData } from "Pages/ReportsAlerts/Reports/@signals"
import ReportsCommonPageContent from "Pages/ReportsAlerts/Reports/Common/Page"
import VirtualTourButton, { TourOverlay, TOUR_STEPS } from "./VirtualTour"
import ReportsDemoData from "./VirtualTour/DemoData"

export default function CommonReports() {
	const [tourActive, setTourActive] = useState(false)
	const showDemoData = tourActive && !reportListData.value?.length

	return <PageWrapper
		head={`DS Rentacar | ${REPORT_ROUTES.TITLE}`}
		title={REPORT_ROUTES.TITLE}
		isEmpty={false}
		actions={<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
			<ReportIconsLegend/>
			<VirtualTourButton onClick={() => setTourActive(true)} />
		</Box>}
	>
		<ReportsCommonPageContent hideCrudTable={showDemoData}/>
		{showDemoData && <ReportsDemoData/>}
		{tourActive && createPortal(
			<TourOverlay steps={TOUR_STEPS} onClose={() => setTourActive(false)} />,
			document.body
		)}
	</PageWrapper>
}